import React from 'react';
import c from 'classnames';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import camelCase from 'lodash/camelCase';
import ddt from '@wix/da-ddt';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ZoneContext from '../../context/ZoneContext/ZoneContext';
import AddWidget from '../AddWidget';
import { useZoneModules } from '../../hooks/useZone';
import usePrivileges from '../../hooks/usePrivileges';
import { filterAlreadyInstalledAndCoreRestrictedModules, getInstallableWidgets } from './utils';
import s from './Zone.scss';
const Zone = ({ className, withStaticAddWidget, widgetConfigs, name, direction = 'column', locked })=>{
    const { canAddModule } = usePrivileges();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { installedModules, installableModules } = useZoneModules(name);
    const installableModulesFiltered = filterAlreadyInstalledAndCoreRestrictedModules(installableModules, installedModules);
    const installableWidgets = getInstallableWidgets(widgetConfigs, installableModulesFiltered);
    ddt.log('grusers', 'Installed modules:', {
        zone: name,
        installedModules
    });
    if (!installedModules.length && !canAddModule) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], withStaticAddWidget && s['static-add-widget'], className, s[direction]),
        key: name
    }, /*#__PURE__*/ React.createElement(ZoneContext.Provider, {
        value: {
            name,
            direction,
            locked
        }
    }, installedModules.map((module, index)=>{
        const isLast = index === installedModules.length - 1;
        const widgetConfig = widgetConfigs[camelCase(module.name)];
        if (!widgetConfig) {
            return null;
        }
        ddt.log('grusers', 'Widget to render:', {
            zone: name,
            widgetConfig
        });
        const isColumn = direction === 'column';
        const { viewComponent: WidgetComponent, configPopoverComponent, autoShowWidgetConfig, confirmRemove, isWide } = widgetConfig;
        const widgetBoxProps = {
            configPopoverComponent,
            autoShowWidgetConfig,
            confirmRemove: confirmRemove ? confirmRemove({
                t,
                dispatch
            }) : undefined,
            className: s['item']
        };
        return /*#__PURE__*/ React.createElement(ErrorBoundary, {
            debugComponent: "Zone",
            key: index
        }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
            value: {
                sectionname: `${module.name}_widget`
            }
        }, WidgetComponent && /*#__PURE__*/ React.createElement(WidgetComponent, {
            key: index,
            moduleId: module.id,
            widgetBoxProps: widgetBoxProps,
            isWide: isWide
        })), installableWidgets.length > 0 && !isLast && !locked && isColumn && /*#__PURE__*/ React.createElement(AddWidget, {
            key: `add-after-${index}`,
            position: index + 1,
            installableWidgets: installableWidgets
        }));
    })));
};
Zone.displayName = 'Zone';
export default Zone;

//# sourceMappingURL=Zone.js.map